import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Helmet } from 'react-helmet';
import { baseDomain } from '../../../common/config';

import styles from './styles.module.css';
import { useReportViewEvent } from '../../../tracking/hooks';

interface ErrorMessageProps {
  teamMemberId: string;
  invitationId: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ teamMemberId, invitationId }: ErrorMessageProps) => {
  useReportViewEvent({
    pageTitle: 'primary_account_change.error',
  });
  return (
    <>
      <Helmet>
        <title>Abgelaufener oder ungültiger Aktivierungslink</title>
      </Helmet>

      <div className='margin-vertical-xl align-center'>
        <h1 className='margin-none'>
          <FormattedMessage id='teammember.invitation.error' />
        </h1>
        <div>
          <img
            alt='errorImage'
            src='//www.static-immobilienscout24.de/statpic/error-page/1b897f0c0bc19ff74d68346f75fdef25_IS24_ErrorPage.svg'
            onError={() => "this.src='//etc/designs/is24/img/immoscout24.png';this.onerror=null;"}
            style={{ height: 200 }}
          />
          <p className='font-bold margin-bottom-s'>
            <FormattedMessage id='teammember.invitation.error.additionalInformation' />
          </p>
          <a href={'//' + baseDomain()} className='button-primary margin-bottom-l'>
            <FormattedMessage id='teammember.invitation.error.button.homepage' />
          </a>
          <p>
            <FormattedMessage id='teammember.invitation.error.thankingMessage' />
          </p>
          <p className={styles.additionalErrorInfo}>
            member_id: {teamMemberId}, invitation_id: {invitationId}
          </p>
        </div>
      </div>
    </>
  );
};

export default ErrorMessage;
